import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import MailIcon from '@material-ui/icons/Mail';
import PhoneIcon from '@material-ui/icons/Phone';
import LinkIcon from '@material-ui/icons/Link';
import ClassIcon from '@material-ui/icons/Class';
import PersonIcon from '@material-ui/icons/Person';
import DescriptionIcon from '@material-ui/icons/Description';
import FontDownloadIcon from '@material-ui/icons/FontDownload';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Header from 'components/Header';
import Form from 'components/Organisations/Form';
import { compact } from 'lodash';

const styles = {
  icon: {
    color: '#8296aa',
    width: '20px',
    marginRight: '10px'
  }
};

class InfoBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = { organisation: props.organisation };
  };

  addressDisplay = (organisation) => {
    const address = organisation.addresses[0]
    return address && `${address.streetAddress}, ${address.suburb} ${address.state} ${address.postcode}`
  }

  fullNameDisplay = (organisation) => {
    return compact([organisation.firstName, organisation.lastName]).join(' ')
  }

  renderDetails = () => {
    const { organisation, classes } = this.props;

    return organisation && (
      <List>
        <ListItem>
          <PersonIcon className={classes.icon}/>
          {this.fullNameDisplay(organisation)}
        </ListItem>
        <ListItem>
          <ClassIcon className={classes.icon}/>
          {organisation.organisationType}
        </ListItem>
        <ListItem>
          <PhoneIcon className={classes.icon}/>
          {organisation.phone}
        </ListItem>
        <ListItem>
          <LocationCityIcon className={classes.icon}/>
          {this.addressDisplay(organisation)}
        </ListItem>
        <ListItem>
          <MailIcon className={classes.icon}/>
          <a href={`mailto:${organisation.email}`}>
            {organisation.email}
          </a>
        </ListItem>
        <ListItem>
          <LinkIcon className={classes.icon}/>
          {organisation.website}
        </ListItem>
        <ListItem>
          <FontDownloadIcon className={classes.icon}/>
          {organisation.abn}
        </ListItem>
        <ListItem>
          <DescriptionIcon className={classes.icon}/>
          {organisation.description}
        </ListItem>
      </List>
    );
  }

  render = () => {
    const { organisation, classes } = this.props;
    if (!organisation) return null;

    const orgId = organisation.id

    return (
      <Paper style={{padding: 20}}>
        <Header heading='Company Details'>
          <Form
            buttonStyles={classes.headerButton}
            buttonLabel='EDIT'
            orgId={orgId}
          />
        </Header>
        <Divider />
        {this.renderDetails()}
      </Paper>
    );
  };
}

export default withStyles(styles)(InfoBox);



// WEBPACK FOOTER //
// ./src/components/Organisations/InfoBox.js